module.exports = __webpack_public_path__ + "static/media/tStatus.f917a38b.png";